function mount() {
  const btnToggle = document.querySelectorAll('[data-action="toggle-search-bar"]');

  let isOpen = false;

  [...btnToggle].forEach((btn) => {
    btn.addEventListener('click', () => {
      const popup = document.querySelector(btn.getAttribute('aria-controls'));
      const fieldset = popup.querySelector('form[role="search"] > fieldset');

      isOpen = !isOpen;
      fieldset.disabled = !isOpen;
      popup.classList.toggle('is--open', isOpen);
      document.body.classList.toggle('is--search-panel-open', isOpen);
    });
  });
}

function init() {
  mount();
}

export default init;
